var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.286,
    y: 0.286,
    width: 39.429,
    height: 39.429,
    rx: 19.714,
    fill: "#00A76F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.114 20.538l4.929 5.376 10.843-11.828",
    stroke: "#fff",
    strokeWidth: 2.629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC4yODU2NDUiIHk9IjAuMjg1NzA2IiB3aWR0aD0iMzkuNDI4NiIgaGVpZ2h0PSIzOS40Mjg2IiByeD0iMTkuNzE0MyIgZmlsbD0iIzAwQTc2RiIvPgo8cGF0aCBkPSJNMTIuMTE0MyAyMC41Mzc2TDE3LjA0MjggMjUuOTE0M0wyNy44ODU3IDE0LjA4NTciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMi42Mjg1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgGreenCheck as ReactComponent };